import React from 'react';

import { css } from 'glamor';

import { spring, TransitionMotion } from 'react-motion';

import { withNotifications } from 'depop/components/NotificationsProvider';

class NotificationsList extends React.Component {
  willLeave() {
    return {
      opacity: spring(0),
      marginTop: spring(-58),
      marginLeft: spring(10),
    };
  }

  willEnter() {
    return {
      opacity: 0,
      marginTop: 5,
      marginLeft: 300,
    };
  }

  render() {
    const { notifications, removeNotification } = this.props;

    return (
      <TransitionMotion
        willLeave={this.willLeave}
        willEnter={this.willEnter}
        styles={notifications.map(notification => ({
          key: notification.id,
          data: notification,
          style: {
            opacity: spring(1),
            marginTop: 5,
            marginLeft: spring(10),
          },
        }))}>
        {interpolatedStyles => (
          <ul
            {...css({
              position: 'fixed',
              top: 62,
              right: 24,
              zIndex: 99999,
              listStyleType: 'none',
              margin: 0,
              padding: 0,
              width: 300,
              overflowX: 'hidden',
            })}>
            {interpolatedStyles.map(config => {
              const color = config.data.status === 'error'
                ? '#d81f2a'
                : '#266e1c';
              return (
                <li
                  key={config.key}
                  style={config.style}
                  {...css({
                    fontSize: 14,
                    backgroundColor: '#fff',
                    padding: 16,
                    color,
                    borderLeft: `4px solid ${color}`,
                    margin: 0,
                    marginBottom: 16,
                    marginRight: 10,
                    width: 280,
                    userSelect: 'none',
                    cursor: 'pointer',
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.25)',
                  })}
                  onClick={() => removeNotification(config.data.id)}>
                  {config.data.content}
                </li>
              );
            })}
          </ul>
        )}
      </TransitionMotion>
    );
  }
}

export default withNotifications(NotificationsList);



// WEBPACK FOOTER //
// ../src/client/components/NotificationsList/NotificationsList.js